module.exports = __webpack_public_path__ + "static/media/29ADMSPC37.9a177ade.jpg";